import { render } from "./Toast.vue?vue&type=template&id=22cb3c89&scoped=true&ts=true"
import script from "./Toast.vue?vue&type=script&lang=ts"
export * from "./Toast.vue?vue&type=script&lang=ts"

import "./Toast.vue?vue&type=style&index=0&id=22cb3c89&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Xabie\\OneDrive\\Desktop\\Proyectos\\Dream\\web\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22cb3c89"]])

export default __exports__